class Gift {
  static data = window.free_gifts ?? [];

  static getGiftById(id) {
    return Gift.data[Number(id)];
  }

  static async _checkMultipleInventoryVariants(variantIds) {
    if (!Array.isArray(variantIds) || variantIds.length === 0) {
      return [];
    }
  
    try {
      const fetchPromises = variantIds.map(variantId => 
        fetch(`/variants/${variantId}.js`).then(response => {
          if (!response.ok) {
            throw new Error(`Failed fetching variant ${variantId}`);
          }
          return response.json();
        })
      );
  
      const variants = await Promise.all(fetchPromises);
  
      return variants.map(variant => ({
        variantId: variant.id,
        available: variant?.available
      }));
    } catch (error) {
      return [];
    }
  }

  static async _checkInventoryVariant(variantId) {
    if (!variantId) return false;

    const response = await fetch(`/variants/${variantId}.js`);
    if (!response.ok) throw new Error(`Failed fetching variant ${variantId}`);

    const variant = await response.json();
    return variant?.available;
  }
}

class ProductForm extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this._onSubmit.bind(this));
  }

  connectedCallback() {
    this.id.disabled = false;
  }

  async _onSubmit(event) {
    event.preventDefault();
  
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }

    this._toggleSubmitButtons(true);
    const sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set(
      "sections_url",
      `${Shopify.routes.root}variants/${this.id.value}`
    );

    // begin add gift
    const gift = Gift.getGiftById(this.id.value);
    const isGiftAvailable = await Gift._checkInventoryVariant(gift?.gift_id)

    const glassesAddOnCheckbox = document.getElementById("glassesAddOn");
    if (gift && isGiftAvailable && (!glassesAddOnCheckbox || glassesAddOnCheckbox.checked)) {
      formData.append(`items[${gift.gift_id}][id]`, gift.gift_id);
      formData.append(`items[${gift.gift_id}][quantity]`, 1);
    }
    // end add gift

    const response = await this._submitFormData(formData);
    this._toggleSubmitButtons(false);
    await this._handleResponse(response);
  }

  _toggleSubmitButtons(disabled) {
    Array.from(this.elements)
      .filter((button) => button.type === "submit")
      .forEach((submitButton) => {
        submitButton.toggleAttribute("disabled", disabled);
        submitButton.setAttribute("aria-busy", disabled);
      });
  }

  async _submitFormData(formData) {
    return await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
  }

  async _handleResponse(response) {
    const responseJson = await response.json();
    if (response.ok) {
      this._handleSuccess(responseJson);
    } else {
      this._handleError(responseJson);
    }
  }

  async _handleSuccess(responseJson) {
    const cartContent = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();
    cartContent["sections"] = responseJson["sections"];

    this.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cartContent },
      })
    );

    if (["page", "cart"].includes(window.themeVariables.settings.cartType)) {
      window.location.href = `${Shopify.routes.root}cart`;
    }
  }

  _handleError(responseJson) {
    this.dispatchEvent(
      new CustomEvent("cart:error", {
        bubbles: true,
        detail: { error: responseJson.description },
      })
    );
  }
}

class ProductDetail {
  constructor() {
    this._initializeGift();
    this._setupEventListeners();
  }

  async _initializeGift() {
    const offerContainer = document.querySelector(".offer-container");
    const idItem = $(".product-info__buy-buttons input[name=id]").val()
    const gift = Gift.getGiftById(idItem);

    if (!gift) {
      this._hideGift(offerContainer);
      return;
    }

    this.isAvailable = await Gift._checkInventoryVariant(gift.gift_id);
    this._updateGiftDetails(gift);
    this._showGift(offerContainer);
  }

  _updateGiftDetails(gift) {
    document.querySelector(".offer-label img").src = gift.gift_link;
    document.querySelector(".main-text").textContent = gift.gift_name;
    document.querySelector(".sub-text").textContent = gift.note;
  }

  _setupEventListeners() {
    const paymentTermsVariantId = document.querySelector(".payment-terms-variant-id");
    paymentTermsVariantId?.addEventListener("change", () => this._initializeGift());
  }

  _showGift(offerContainer) {
    const checkBox = document.querySelector('#glassesAddOn');
    offerContainer.hidden = false;

    if (this.isAvailable) {
      $(".gift-out-of-stock-alert").attr("hidden", true);
      checkBox.checked = true;
      $(".checkbox-gift").attr("hidden", false);
    } else {
      $(".checkbox-gift").attr("hidden", true);
      checkBox.checked = false;
      $(".gift-out-of-stock-alert").attr("hidden", false);
    }
  }

  _hideGift(offerContainer) {
    offerContainer.hidden = true;
    $(".gift-out-of-stock-alert").attr("hidden", true);
  }
}

// Initial setup and event handling
$(document).ready(() => {
  if (
    window.location.pathname.includes("/products/")
  ) {
    new ProductDetail();
  }
  if (!window.customElements.get("product-form")) {
    window.customElements.define("product-form", ProductForm, {
      extends: "form",
    });
  }
});
